module.exports = __webpack_public_path__ + "static/media/EUA.2afa2844.svg";